module.exports = __webpack_public_path__ + "img/700lx.598b58aa.webp";